import { images } from ".";

const clients = [
    images.client1,
    images.client2,
    images.client3,
    images.client4,
    images.client5,
    images.client6,
    images.client7,
    images.client8,
];

export default clients;